import Variable from '../../constants/constants.json';
import { GET_CONSTANTS } from '../Constants/constants.constants';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const getConstantsData = () => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/constants`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    };
    try {
        const result = await createRequest(options);
        dispatch({
            type: GET_CONSTANTS,
            data: result.data
        });
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: GET_CONSTANTS,
            data: {}
        });
    }
};
